import styled, { css } from 'styled-components';

import { colors } from '../../styles/stylesheets';
import { ContainerShadowStyled } from '../../components/ContainerShadowStyled';
import imgPolvoPiscando from '../../assets/img/polvo-piscando.svg';
import {
  SliderContainer,
  Slider,
  SliderPrevious,
  SliderNext,
} from '../../components/Slider';

export const Container = styled(SliderContainer)`
`;

export const SliderCustom = styled(Slider)`
  overflow-x: hidden;
`;
export const SliderButton = css`
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  font-size: 1.4rem;
  color: ${colors.greyDark};
  background: ${colors.greyLighter2};
`;
export const ButtomPrevious = styled(SliderPrevious)`
  ${SliderButton}
`;
export const ButtomNext = styled(SliderNext)`
  ${SliderButton}
`;

export const Medal = styled(ContainerShadowStyled)`
  flex: 1;
  padding: 20px;
  margin: 20px 20px 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  :last-child {
    margin-right: 0;
  }
`;

export const IconOctopus = styled.div`
  width: 102px;
  height: 102px;
  background: url(${imgPolvoPiscando});
`;

export const Title = styled.div`
  padding: 20px 0;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.primary};
  font-weight: 500;
`;

export const Description = styled.div`
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  font-weight: 400;
`;
